import { createSvgIcon } from '@mui/material';

export const IconBinocular = createSvgIcon(
  <svg
    width="106"
    height="106"
    viewBox="0 0 106 106"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1545_15233)">
      <path
        d="M22.5025 101.261C32.859 101.261 41.2547 92.8658 41.2547 82.5093C41.2547 72.1528 32.859 63.7572 22.5025 63.7572C12.146 63.7572 3.75042 72.1528 3.75042 82.5093C3.75042 92.8658 12.146 101.261 22.5025 101.261Z"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.2547 22.5027V11.2514C41.2547 9.26204 40.4644 7.35417 39.0577 5.94749C37.651 4.5408 35.7432 3.75054 33.7538 3.75054H24.9028C23.1374 3.71843 21.4173 4.31014 20.0452 5.42151C18.6732 6.53287 17.7372 8.09264 17.402 9.82622L4.12547 78.759"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.7538 41.2547H71.258"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41.2547 60.0068V82.5093"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M82.5093 101.261C92.8658 101.261 101.261 92.8658 101.261 82.5093C101.261 72.1528 92.8658 63.7572 82.5093 63.7572C72.1528 63.7572 63.7572 72.1528 63.7572 82.5093C63.7572 92.8658 72.1528 101.261 82.5093 101.261Z"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.7572 22.5027V11.2514C63.7572 9.26204 64.5475 7.35417 65.9542 5.94749C67.3608 4.5408 69.2687 3.75054 71.258 3.75054H80.109C81.8744 3.71843 83.5946 4.31014 84.9666 5.42151C86.3387 6.53287 87.2747 8.09264 87.6099 9.82622L101.036 78.759"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M63.7572 60.0068V82.5093"
        stroke="currentColor"
        stroke-width="7.50085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1545_15233">
        <rect width="105.012" height="105.012" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'IconBinocular',
);
